import React from 'react'

interface HeadingProps {
  title: string
  color?: string
  level?: number
  bold?: boolean
}

const Heading = ({ title, color, level = 2, bold = false }: HeadingProps) => {
  if (level) {
    return React.createElement(
      `h${level}`,
      {
        className: `${color ? 'text' + color : ''} ${bold ? 'fw-bold' : ''} ${level === 2 ? 'mb-16' : ''} ${level === 4 ? 'h4-custom-margin' : ''}`,
      },
      title
    )
  }
}

export default Heading
